import { formatEur, toMoney } from "./tpvCalc";

function esc(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function money(n) {
  return toMoney(n).toFixed(2).replace(".", ",");
}

const PRINT_CSS = `
  @page { margin: 8mm; size: auto; }
  * { box-sizing: border-box; }
  body {
    margin: 0;
    padding: 12px;
    background: #f3f4f6;
    color: #111;
    font-family: "Segoe UI", Arial, Helvetica, sans-serif;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .ticket {
    width: 320px;
    margin: 0 auto;
    background: #fff;
    border: 1px solid #d1d5db;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  }
  .accent {
    height: 5px;
    background: linear-gradient(90deg, #0d9488, #14b8a6 55%, #64748b);
  }
  .inner { padding: 16px 16px 18px; }
  .logo { text-align: center; margin-bottom: 10px; }
  .logo img { width: 78px; height: auto; }
  .brand {
    text-align: center;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.02em;
    margin: 0 0 4px;
  }
  .meta {
    text-align: center;
    font-size: 11px;
    line-height: 1.45;
    color: #4b5563;
    margin: 0;
  }
  .sep {
    border: 0;
    border-top: 1px dashed #cbd5e1;
    margin: 12px 0;
  }
  .doc-title {
    margin: 0;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
  .doc-sub {
    margin: 4px 0 0;
    font-size: 11px;
    color: #64748b;
  }
  .head {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-top: 12px;
    padding: 6px 8px;
    border-radius: 6px;
    background: #f1f5f9;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #475569;
  }
  .lines { margin-top: 4px; }
  .line {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    padding: 7px 2px;
    border-bottom: 1px solid #f1f5f9;
    font-size: 12px;
    align-items: start;
  }
  .line:last-child { border-bottom: 0; }
  .concepto {
    min-width: 0;
    word-break: break-word;
    line-height: 1.35;
  }
  .qty {
    display: inline-block;
    margin-right: 4px;
    font-weight: 800;
    color: #0f766e;
  }
  .importe {
    font-weight: 700;
    white-space: nowrap;
    text-align: right;
  }
  .iva {
    margin-top: 10px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
  }
  .iva-head, .iva-row {
    display: grid;
    grid-template-columns: 1.1fr 0.7fr 1fr 1.2fr;
    gap: 4px;
    padding: 7px 8px;
    font-size: 11px;
  }
  .iva-head {
    background: #f8fafc;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #64748b;
    font-size: 9px;
  }
  .iva-row { font-weight: 600; }
  .iva-row span, .iva-head span {
    text-align: right;
    white-space: nowrap;
  }
  .iva-row span:first-child, .iva-head span:first-child { text-align: left; }
  .iva-row .total {
    font-weight: 800;
    color: #0f766e;
  }
  .pay {
    margin-top: 10px;
    font-size: 11px;
    color: #475569;
  }
  .pay-row {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-top: 3px;
  }
  .attn {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-top: 12px;
    font-size: 11px;
    color: #334155;
  }
  .attn strong { font-weight: 800; }
  .thanks {
    margin: 16px 0 2px;
    text-align: center;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.06em;
    color: #0f766e;
  }
  .foot {
    text-align: center;
    font-size: 10px;
    color: #94a3b8;
    margin: 0;
  }
  .kpi {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    padding: 6px 2px;
    font-size: 12px;
    border-bottom: 1px solid #f1f5f9;
  }
  .kpi:last-child { border-bottom: 0; }
  .kpi strong { font-weight: 800; white-space: nowrap; }
  .kpi.em {
    margin-top: 6px;
    padding: 8px;
    border-radius: 8px;
    background: #ecfdf5;
    border: 1px solid #a7f3d0;
  }
  @media print {
    body { background: #fff; padding: 0; }
    .ticket {
      width: 72mm;
      max-width: 100%;
      border: 0;
      border-radius: 0;
      box-shadow: none;
    }
  }
`;

export function openTpvPrintWindow(html) {
  const w = window.open(
    "",
    "print",
    "directories=no,location=no,menubar=no,scrollbars=yes,status=no,width=420,height=860",
  );
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}

function companyBlock(company, logo) {
  return `
    <div class="accent"></div>
    <div class="inner">
      <div class="logo"><img src="${logo}" alt="Stage Design" onerror="this.style.display='none'" /></div>
      <p class="brand">${esc(company.name || "STAGE DESIGN STUDIO")}</p>
      <p class="meta">NIF: ${esc(company.nif || "")}</p>
      <p class="meta">${esc(company.line2 || "")}</p>
      <p class="meta">${esc(company.line3 || "")}</p>
  `;
}

export function ticketPrintHtml({ company, ticket, iva }) {
  const logo = `${window.location.origin}/tpv/ticketcajalogo.png`;
  const lines = (ticket.lineas || [])
    .map((l) => {
      const lineTotal =
        l.importe != null
          ? l.importe
          : Number(l.cantidad || 0) * Number(l.pvp || 0);
      return `
      <div class="line">
        <div class="concepto"><span class="qty">${esc(l.cantidad)}×</span>${esc(l.concepto)}</div>
        <div class="importe">${money(lineTotal)} €</div>
      </div>`;
    })
    .join("");

  const efectivo = toMoney(ticket.efectivo);
  const tarjeta = toMoney(ticket.tarjeta);
  const payRows = [];
  if (efectivo > 0) {
    payRows.push(
      `<div class="pay-row"><span>Efectivo</span><strong>${money(efectivo)} €</strong></div>`,
    );
  }
  if (tarjeta > 0) {
    payRows.push(
      `<div class="pay-row"><span>Tarjeta</span><strong>${money(tarjeta)} €</strong></div>`,
    );
  }

  return `<!doctype html><html><head><meta charset="utf-8"><title>Ticket ${esc(ticket.nTicket)}</title>
  <style>${PRINT_CSS}</style></head>
  <body onload="window.print()">
    <div class="ticket">
      ${companyBlock(company, logo)}
      <hr class="sep" />
      <p class="doc-title">Factura simplificada</p>
      <p class="doc-sub">Nº ${esc(ticket.nTicket)} · ${esc(ticket.openedAtLabel || "")}</p>
      <div class="head"><span>Concepto</span><span>Importe</span></div>
      <div class="lines">${lines || `<div class="line"><div class="concepto">—</div><div class="importe">0,00 €</div></div>`}</div>
      <div class="iva">
        <div class="iva-head"><span>Base</span><span>IVA</span><span>Cuota</span><span>Total</span></div>
        <div class="iva-row">
          <span>${money(iva.base)}</span>
          <span>${esc(iva.ivaPct)}%</span>
          <span>${money(iva.ivaImporte)}</span>
          <span class="total">${money(iva.total)} €</span>
        </div>
      </div>
      ${payRows.length ? `<div class="pay">${payRows.join("")}</div>` : ""}
      <div class="attn"><span>Fue atendido por</span><strong>${esc(ticket.openedByName || "")}</strong></div>
      <p class="thanks">MIL GRACIAS POR SU VISITA</p>
      <p class="foot">Stage Design Studio · Sitges</p>
      </div>
    </div>
  </body></html>`;
}

export function cajaPrintHtml({ company, caja, enCaja }) {
  const logo = `${window.location.origin}/tpv/ticketcajalogo.png`;
  return `<!doctype html><html><head><meta charset="utf-8"><title>Caja #${esc(caja.id)}</title>
  <style>${PRINT_CSS}</style></head>
  <body onload="window.print()">
    <div class="ticket">
      ${companyBlock(company, logo)}
      <hr class="sep" />
      <p class="doc-title">Cierre de caja #${esc(caja.id)}</p>
      <p class="doc-sub">Apertura: ${esc(caja.openedAtLabel || "—")}</p>
      <p class="doc-sub">Cierre: ${esc(caja.closedAtLabel || "—")}</p>
      <hr class="sep" />
      <div class="kpi"><span>Cobro efectivo</span><strong>${money(caja.ingMetalico)} €</strong></div>
      <div class="kpi"><span>Cobro tarjeta</span><strong>${money(caja.ingTarjeta)} €</strong></div>
      <div class="kpi"><span>Tickets abiertos</span><strong>${esc(caja.openTickets || 0)}</strong></div>
      <div class="kpi"><span>Apertura</span><strong>${money(caja.importeIni)} €</strong></div>
      <div class="kpi"><span>Ingresos totales</span><strong>${money(caja.ingTotal)} €</strong></div>
      <div class="kpi em"><span>En caja</span><strong>${money(enCaja)} €</strong></div>
      <div class="kpi"><span>Entregado</span><strong>${money(caja.aEntregar)} €</strong></div>
      ${
        caja.closedByName
          ? `<div class="attn"><span>Cerrado por</span><strong>${esc(caja.closedByName)}</strong></div>`
          : ""
      }
      <p class="thanks">RESUMEN DE CAJA</p>
      <p class="foot">Stage Design Studio · Sitges</p>
      </div>
    </div>
  </body></html>`;
}

export { formatEur };
